// ABOUTME: Variation code banner for the order confirmation section.
// Uses confirmation-specific i18n keys when offsetValue !== 'PT0S' (rescheduled).

import {Alert} from '@hm/fundamental'
import {ErrorOutline, WarningAmber} from '@mui/icons-material'
import {Box} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {
  formatTimespanOffset,
  getTopBannerVariant,
  isTopBannerCode
} from '../../../../../../../Pages/Order/variationCode.utils'

const variantConfig = {
  error: {Icon: ErrorOutline, iconColor: '#991B1B'},
  warning: {Icon: WarningAmber, iconColor: '#b45309'}
} as const

interface ConfirmationVariationCodeBannerProps {
  variationCode: string
  variationCodeOffset: string
}

export const ConfirmationVariationCodeBanner: React.FC<ConfirmationVariationCodeBannerProps> = ({
  variationCode,
  variationCodeOffset
}) => {
  const {t} = useTranslation()

  if (!isTopBannerCode(variationCode)) return null

  const offsetValue = formatTimespanOffset(variationCodeOffset, t)

  const variant = getTopBannerVariant(variationCode, offsetValue)
  
  if (!variant) return null

  const {Icon, iconColor} = variantConfig[variant]

  const title =
    offsetValue === 'PT0S'
      ? t('order.variationCode.UE.banner.title')
      : t('order.variationCode.confirmation.banner.title')
  const description =
    offsetValue === 'PT0S'
      ? t('order.variationCode.UE.banner.description')
      : t('order.variationCode.confirmation.banner.description')

  return (
    <Alert
      variant={variant}
      data-test-id={`variation-code-banner-top-${variationCode}`}
      className="mt-2"
    >
      <Box sx={{display: 'flex', gap: '12px', alignItems: 'flex-start'}}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0
          }}
        >
          <Icon sx={{fontSize: '20px', color: iconColor}} />
        </Box>
        <Box sx={{display: 'flex', flexDirection: 'column', gap: '4px'}}>
          <Box component="span" sx={{fontWeight: 600}}>
            {title}
          </Box>
          <Box component="span">
            {description}
          </Box>
        </Box>
      </Box>
    </Alert>
  )
}
